export const SCHEDULE_COMPLEX_CARE_CALL_LINK = 'https://go.oncehub.com/complexcarenav'
export const SCHEDULE_DBT_CALL_LINK = 'https://go.oncehub.com/LyraBCDBTAssessmentCall'
